import React from 'react'
import './DescriptionBox.css'
 
const DescriptionBox = () => {
 
  return (
    <div className='descriptionbox'>
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">Description</div>
      </div>
      <div className='descriptionbox-description'>
          <p>Every item on this website is handmade by me! If you want any custom made item, send over a Picture, Color, Size, and description of any item to my <a id='ig-link' href='https://www.instagram.com/mariemadeit__/?hl=en'>Instagram</a> and I will respond ASAP!</p>
          <div>
            <p><strong>For digital PDF crochet pattern</strong> — no physical item will be shipped.</p>
            <p>After completing your purchase you will receive an email with a secure download link for your pattern. The PDF includes:</p>
            <ul>
              <li>Step-by-step written instructions</li>
              <li>Materials and hook size needed</li>
              <li>Skill level and sizing information</li>
              <li>Stitch abbreviations and guide</li>
            </ul>
            <p>If you have any questions about the pattern, feel free to reach out on <a id='ig-link' href='https://www.instagram.com/mariemadeit__/?hl=en'>Instagram</a></p>
          </div>
      </div>
    </div>
  )
}
 
export default DescriptionBox